<div class="subbanner" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
    <div class="container position-relative">
        <div class="subbanner__title">
            <h1 class="primary-title">Career</h1>
        </div>
    </div>
</div>

<div class="career-info padding-section" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
    <div class="container">
        <h2 class="primary-title">We Are Hiring ! <h6> Join Our Team</h6></h2>
        <ul class="career-info__list list-unstyled">
            <li *ngFor="let item of careerInfo">
                <div class="career-info__list__firstpos">
                  <h4 class="secondary-title">{{ item.Role }}</h4>
                  <span class="city-exper">{{ item.Location }} / {{ item.Education }} / {{ item.Experience }}</span>
                  <div class="career-info__list__job-descip" >
                    <h5 class="descri-title">Description</h5>
                    <ul class="list-unstyled" *ngFor="let item2 of item.data">
                      <li>{{ item2.Job_Desceription }}</li>
                      
                    </ul>
                  </div>
                </div>
                <div class="career-info__list__apply">
                  <button class="btn btn-primary fw-bold read-morebtn" (click)="openDialog()">Apply</button>
                </div>
              </li>
              

            <!-- <li>
                <div class="career-info__list__firstpos">
                    <h4 class="secondary-title">Commercial & Contracting Executive</h4>
                    <span class="city-exper">Pune / Graduate or Post Graduate / 1-5 years</span>
                    <div class="career-info__list__job-descip">
                        <h5 class="descri-title">Description</h5>
                        <ul class="list-unstyled">
                            <li>Giving quotations, speaking with suppliers,negotiating rates.</li>
                            <li>Establishing new suppliers.</li>
                            <li>Understand competitors strategies.</li>
                            <li>Working towards zero issues/concerns on tours.</li>
                            <li>Creating Domestic & International Database</li>
                            <li>To understand the guest target of the organization</li>
                        </ul>
                    </div>
                </div>
                <div class="career-info__list__apply">
                    <button class="btn btn-primary fw-bold read-morebtn" (click)="openDialog()">Apply</button>
                </div>
            </li> -->
        </ul>
    </div>
</div>